import type { FC, PropsWithRef, Ref } from "react";
import { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
import {
  Cropper,
  type CropperRef,
  type CropperProps,
} from "react-advanced-cropper";

export interface ImageCropperHandle {
  ref?: CropperRef;
  getCropped(): Promise<{
    width: number;
    height: number;
    file: Blob;
  }>;
}
export const ImageCropper: FC<
  PropsWithRef<CropperProps & { ref?: Ref<ImageCropperHandle> }>
> = forwardRef(({ src, ...props }, ref) => {
  const cropper = useRef<CropperRef>(null);

  const getCropped = useCallback(async (cropper: CropperRef | null) => {
    if (!cropper) {
      throw new Error("Cannot get cropper");
    }
    const canvas = cropper.getCanvas();
    const dataUrl = canvas?.toDataURL();
    console.debug("[index] [Line 26]: dataUrl", dataUrl);
    const file: Blob | null = await new Promise((resolve) => {
      canvas?.toBlob(resolve);
    });
    if (!file || !canvas) throw new Error("Cannot get blob");
    const { width, height } = canvas;
    return {
      width,
      height,
      file,
    };
  }, []);
  useImperativeHandle(
    ref,
    () => ({
      getCropped: () => getCropped(cropper.current),
    }),
    [getCropped]
  );
  return (
    <Cropper {...props} ref={cropper} src={src} zoomImageAlgorithm={false} />
  );
});

ImageCropper.displayName = "ImageCropper";
